var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopNav"},_vm._l((_vm.navList),function(item){return _c('a',{attrs:{"href":item.url,"index":item.text}},[_vm._v(_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }